"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * EditStudentProgramPage - Temporary dev page for sidebar link
 *
 * Provides a form to input a studentProgramId and navigate to the student edit page.
 */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const Button_1 = require("../../components/Button");
const Input_1 = require("../../components/Input");
const EditStudentProgramPage = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [studentProgramId, setStudentProgramId] = (0, react_1.useState)('');
    const [profileId, setProfileId] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const UUID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (!studentProgramId.trim()) {
            setError('Student Program ID is required');
            return;
        }
        if (!UUID_PATTERN.test(studentProgramId.trim())) {
            setError('Student Program ID must be a valid UUID');
            return;
        }
        if (!profileId.trim()) {
            setError('Profile ID is required');
            return;
        }
        if (!UUID_PATTERN.test(profileId.trim())) {
            setError('Profile ID must be a valid UUID');
            return;
        }
        navigate(`/degree-planning/student/${profileId.trim()}/program/${studentProgramId.trim()}/edit`);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "page", style: { maxWidth: '600px' }, children: [(0, jsx_runtime_1.jsx)("h1", { children: "Edit Student Degree Plan" }), (0, jsx_runtime_1.jsx)("p", { children: "Enter the student's Profile ID and Student Program ID to navigate to their degree plan editor." }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, style: { display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1.5rem' }, children: [(0, jsx_runtime_1.jsx)(Input_1.Input, { id: "profile-id", label: "Profile ID", value: profileId, onChange: (e) => setProfileId(e.target.value), placeholder: "e.g., 12345678-1234-1234-1234-123456789012", required: true, fullWidth: true, error: error && error.includes('Profile') ? error : undefined }), (0, jsx_runtime_1.jsx)(Input_1.Input, { id: "student-program-id", label: "Student Program ID", value: studentProgramId, onChange: (e) => setStudentProgramId(e.target.value), placeholder: "e.g., 12345678-1234-1234-1234-123456789012", required: true, fullWidth: true, error: error && error.includes('Student Program') ? error : undefined }), error && !error.includes('Profile') && !error.includes('Student Program') && ((0, jsx_runtime_1.jsx)("div", { role: "alert", style: { color: 'red' }, children: error })), (0, jsx_runtime_1.jsx)(Button_1.Button, { type: "submit", children: "Go to Student Plan" })] })] }));
};
exports.default = EditStudentProgramPage;
